// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../writer-core-master/Product/ItSymphony.Writer.Web/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.react-flow__edge.selected,
.react-flow__edge:focus,
.react-flow__edge:focus-visible {
    outline: none;
}
.react-flow__edge.react-flow__edge-custom.selected .react-flow__edge-path,
.react-flow__edge:focus .react-flow__edge-path,
.react-flow__edge:focus-visible .react-flow__edge-path {
    stroke: #d22e37 !important;
    stroke-width: 6 !important;
}
`, "",{"version":3,"sources":["webpack://./src/app/nlpDesigner/components/customEdge/CustomEdge.css"],"names":[],"mappings":"AAAA;;;IAGI,aAAa;AACjB;AACA;;;IAGI,0BAA0B;IAC1B,0BAA0B;AAC9B","sourcesContent":[".react-flow__edge.selected,\r\n.react-flow__edge:focus,\r\n.react-flow__edge:focus-visible {\r\n    outline: none;\r\n}\r\n.react-flow__edge.react-flow__edge-custom.selected .react-flow__edge-path,\r\n.react-flow__edge:focus .react-flow__edge-path,\r\n.react-flow__edge:focus-visible .react-flow__edge-path {\r\n    stroke: #d22e37 !important;\r\n    stroke-width: 6 !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
